export class ResetPasswordDto {
    public userName: string
    public newPassword: string  
}

